import { useContext, useEffect, useState } from 'react'
import layoutBgImg from '../../Images/layout/others.jpg'
import { useTranslation } from 'react-i18next'
import Layout from '../../Component/layout/main-layout'
import { GetSale } from '../../api/Queries/get'
import { Context } from '../../Store/context'
import Loading from '../../Component/loader/loader'
import SaleSearch from '../../Component/sale/sale-search'
import { Get } from '../../api/services/api_helpers'
import SaleMap from '../../Component/sale/sale-map'
import GlobalLayout from '../../Component/layout/global-layout'

const Sale = () => {
  const [sale, setSale] = useState([])
  const [categories, setCategories] = useState([]);
  const [query, setQuery] = useState('')
  const [minPrice, setMinPrice] = useState('')
  const [maxPrice, setMaxPrice] = useState('')
  const [category, setCategory] = useState('')
  const [location, setLocation] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const { showError } = useContext(Context);
  const { t } = useTranslation()

  useEffect(() => {
    setIsLoading(true)
    const getSale = async () => {
      try {
        const data = await GetSale()
        setIsLoading(false)
        setSale(data)
        const uniqueCategories = [...new Set(data.map(item => item.category))];
        setCategories(uniqueCategories);
      } catch (error) {
        showError(error.message);
        setIsLoading(false)
      }
    }
    getSale()
  }, [showError])

  const handleSearchClick = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (query || category || minPrice || maxPrice || location) {
      try {
        const response = await Get(`auctions/search/?query=${query}&category=${category}&location=${location}&min_price=${minPrice}&max_price=${maxPrice}`);
        setSale(response);
      } catch (error) {
        showError(error.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <GlobalLayout
      title={`${t('sale')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords="Aукцион, Auksion, Jaylar, Emlakler"
    >
      <div className='mb-20'>
        <Layout
          title={t('sale')}
          layoutBgImg={layoutBgImg}
        />
        <div className='media'>

          <div className='bg-white dark:bg-dark-box dark:text-white
                          px-6 xl:px-16 lg:py-4 mt-8 pt-4'>
  
            <SaleSearch
              categories={categories}
              setCategory={setCategory}
              location={location} setLocation={setLocation}
              query={query} setQuery={setQuery}
              minPrice={minPrice} setMinPrice={setMinPrice}
              maxPrice={maxPrice} setMaxPrice={setMaxPrice}
              handleSearchClick={handleSearchClick}
            />

            {isLoading ? <Loading /> :
              <SaleMap sale={sale}/>
            }
            {!sale.length && 'Jemi: 0'}
          </div>
        </div>
      </div>
    </GlobalLayout>
  )
}

export default Sale